<section #chartContainer class="chart-container {{ highChartsAttributes.className || highChartsAttributes.chartType | camelToKebabCase }}-chart"></section>
